<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Passphrase hint</h1>
      <v-divider></v-divider>
      <div class="text-center hint-text">
        <p class="p-5">
          Please use your passphrase hint to access your eBook collections.
        </p>
        <p class="pt-5">
          If you are still unable to access your eBooks, please contact your eBook
          administrator at your institution to request a new passphrase.
        </p>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapGetter, mapActions } from "vuex";
export default {
  name: "PassphraseHint",
  created() {
      this.getLeftMenuCollapse(true);
  },
  components: {},
  computed: {
      ...mapActions(["getLeftMenuCollapse"]),
  },
};
</script>
<style scoped>
.hint-text {
  padding-top: 80px;
  padding-bottom: 140px;
  font-weight: 400;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/views/PassphraseHint.vue